import './Main.css'

const Main = (props) => {
  return (
    <>
      <main>
        {props.children}
      </main>
    </>
  )
}

export default Main
